import { createFileRoute } from '@tanstack/react-router';
import { validateSearch } from '../../../utils/pagination';
import { ButtonLink, PageHeader } from '@maia/ui';
import { IconFire, IconPlus } from '@maia/icons';
import { getClaimsOptions } from '../../../features/claim/claims/queryOptions';
import { ClaimsTable } from '../../../features/claim/claims/table';
import { mapInitialFilters } from '../../../utils/filter/utils';

export const Route = createFileRoute('/_authenticated/claims/')({
  component: Page,
  loaderDeps: ({ search }) => search,
  loader: ({ context: { queryClient }, deps: search }) =>
    queryClient.ensureQueryData(getClaimsOptions(mapInitialFilters(search))),
  validateSearch: validateSearch,
});

export function Page() {
  const data = Route.useLoaderData();

  return (
    <div className="layout-simple">
      <PageHeader
        className="area-page-header"
        icon={IconFire}
        title="Claims"
        actions={
          <ButtonLink
            to="/claims/new"
            intent="cta"
            size="default"
            iconLeft={IconPlus}
          >
            Nieuwe Claim
          </ButtonLink>
        }
      />
      <div className="area-page-content content-grid">
        <div className="col-span-full flex items-center justify-between">
          <ClaimsTable claims={data} />
        </div>
      </div>
    </div>
  );
}
